import { render, staticRenderFns } from "./CategoriesMenu.vue?vue&type=template&id=72b16198"
import script from "./CategoriesMenu.vue?vue&type=script&lang=js"
export * from "./CategoriesMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports